
export const routesWithAccessType = [
  {
      route: "/users",
      accessType: "users"
  },
  {
      route: "/users/new",
      accessType: "users"
  },
  {
      route: "/games",
      accessType: "games"
  },
  {
      route: "/games/upload",
      accessType: "games"
  },
  {
      route: "/games/settings",
      accessType: "games"
  },
  {
      route: "/boxes",
      accessType: "boxes"
  },
  {
      route: "/boxes",
      accessType: "boxes"
  },
  {
      route: "/decksstatus",
      accessType: "decks_status"
  },
  {
      route: "/decksmanagement",
      accessType: "decks_management"
  },
  {
      route: "/bingoconfig",
      accessType: "bingo_config"
  },
  {
      route: "/bingogamelist",
      accessType: "bingo_games"
  },
  {
      route: "/bingogames",
      accessType: "bingo_games"
  },
  {
      route: "/gameorderings",
      accessType: "game_orderings"
  },
  {
      route: "/lobbytabs",
      accessType: "lobby_tabs"
  },
  {
      route: "/queuestatus",
      accessType: ""
  },
  {
      route: "/jackpots",
      accessType: "bingo_jackpots"
  },
  {
      route: "/jackpotshistory",
      accessType: "bingo_jackpot_history"
  },
  {
      route: "/jackpotspayrolls",
      accessType: "bingo_jackpot_payrolls"
  },
  {
      route: "/distributors",
      accessType: "distributors"
  },
  {
      route: "/charities",
      accessType: "charities"
  },
  {
      route: "/locations",
      accessType: "locations"
  },
  {
      route: "/drawermanagement",
      accessType: "drawer_management"
  },
    {
        route: "/seasonalmanagement",
        accessType: "drawer_management"
    },
    {
        route: "/bundlemanagement",
        accessType: "bundle_management"
    },
  {
      route: "/posbundleservermanagement",
      accessType: "pos_bundle_server_management"
  },
  {
      route: "/devices",
      accessType: "devices"
  },
  {
      route: "/deviceversions",
      accessType: "device_versions"
  },
  {
      route: "/cashiers",
      accessType: "cashiers"
  },
  {
      route: "/drawercashiers",
      accessType: "drawer_management"
  },
  {
      route: "/logs",
      accessType: "logs"
  },
  {
      route: "/roles",
      accessType: "roles"
  },
  {
      route: "/migrationqueue",
      accessType: "config"
  },
  {
      route: "/migrationstatus",
      accessType: "config"
  },
  {
      route: "/locationtopology",
      accessType: "locations"
  },
  {
      route: "/manufacturerconfig",
      accessType: "config"
  },
  {
      route: "/messaging",
      accessType: "messaging"
  },
  {
      route: "/locationtopology",
      accessType: "locations"
  }
]

export function getAccessTypeByRoute (route: string) {
    const firstPath = '/' + route.split('/')[1];
    const accessType = routesWithAccessType.filter((param) => param.route === firstPath);
    if (accessType.length > 0) return accessType[0].accessType;
    return ""
}

